/** @jsx jsx */

import { ReactNode } from 'react';
import { css, jsx } from '@emotion/core';

const Styles = {
  root: (margin?: string) => css`
    line-height: inherit;
    margin: ${margin ?? `1em 0`};
    &:last-child {
      margin-bottom: 0;
    }
  `,
};

type Props = {
  children: ReactNode;
  margin?: string;
};

const MessageText = (props: Props) => {
  const { children, margin } = props;

  return <div css={Styles.root(margin)}>{children}</div>;
};

export default MessageText;
